import type {VoidFunctionComponent} from "react";
import React from "react";
import s from "./LibraryLessonCard.module.scss";
import {DifficultyOption} from "../../../models/view/common/DifficultyOption";
import {isDefined} from "../../../util/is-type";
import {LibraryLessonCardMiddle} from "../library-lesson-card-middle/LibraryLessonCardMiddle";
import {CardIconType} from "../../../models/view/common/ICard";
import {LibraryLessonCardTop} from "../library-lesson-card-top/LibraryLessonCardTop";

export interface ILibraryLessonCardProps {
  lessonId: number;
  title: string;
  subTitle?: string;
  number?: number| string;
  stars?: number;
  amountComplete?: number | string;
  difficultyIdentifier?: DifficultyOption;
  difficultyName?: string;
  difficultySubcategory?: string;
  isFavorite?: boolean;
  icon?: CardIconType;
  imageUrl?: string;
  onClick: () => void;
}

// class names that cause card style adjustments
const styledDifficultyClassNames: DifficultyOption[] = [
  "rookie",
  "intermediate",
  "advanced",
];

export const LibraryLessonCard: VoidFunctionComponent<ILibraryLessonCardProps> = ({lessonId, title, subTitle, difficultyIdentifier, difficultyName, icon, imageUrl, isFavorite, number, stars, amountComplete, onClick}) => {
  const cardClassNames = [
    s.card,
  ];
  if (
    // have difficulty
    isDefined(difficultyIdentifier)
    // should difficulty add style
    && styledDifficultyClassNames.includes(difficultyIdentifier)
  ) {
    cardClassNames.push(s[`${difficultyIdentifier}Difficulty`]);
  }
  
  return (
    <div className={cardClassNames.join(` `)} tabIndex={0} onKeyDown={e => e.key === 'Enter' ? onClick() : null}>
      <img alt={"lesson art"} className={s.albumArt} src={imageUrl} width="500" height="500" onClick={onClick}/>
      <LibraryLessonCardTop {...{number, stars, amountComplete, isFavorite, lessonId}} />
      <LibraryLessonCardMiddle {...{title, subTitle, difficultyName, icon, onClick}}/>
      <div className={s.bottom}>&nbsp;</div>
    </div>
  );
}
